// src/components/Support/StatusBadge.jsx
import React from 'react';
import { Chip, Box, Typography } from '@mui/material';
import { SUPPORT_STATUSES, getStatusConfig } from '../../constants/supportConstants';

const StatusBadge = ({ status, size = 'small', showIcon = true }) => {
  const config = getStatusConfig(status);
  
  const colorMap = {
    info: 'info',
    warning: 'warning',
    orange: 'warning',
    purple: 'secondary',
    success: 'success',
    default: 'default',
  };

  return (
    <Chip
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {showIcon && <span>{config.icon}</span>}
          <Typography variant={size === 'small' ? 'caption' : 'body2'}>
            {config.label}
          </Typography>
        </Box>
      }
      color={colorMap[config.color] || 'default'}
      size={size}
      sx={{
        fontWeight: 500,
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};

export default StatusBadge;